import React, { useState, useEffect ,useRef} from 'react';
import { useNavigate } from 'react-router-dom';
import { DebitNotelist ,debitNoteDelete } from '../store/slices/purchase';
import { ListParties } from '../store/slices/parties';
import Loader from '../common/Loader';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import Table from '../common/Table';
import AdminLayout from './AdminLayout';
import {toast } from 'react-hot-toast';
import { FaFilePdf } from "react-icons/fa6";
import {
  API_BASE_URL,
  API_PATHS,
} from "../utils/constants/api.constants";

const DebitNoteList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const tableRef=useRef(null)

  const user = JSON.parse(localStorage.getItem('user'));
  const id = user?.data?.profile_id;

  const [isLoading, setIsLoading] = useState(false);
  const [debitNotelist, setDebitNotelist] = useState([]);
   const [listParties, setListParties] = useState([]);
    const [selectedParty, setSelectedParty] = useState(null); 
  const [columns, setcolumns] = useState([
    { header: 'Debit Note Number', field: 'debit_note_number' },
    { header: 'Purchase Voucher', field: 'purchase_voucher_id' },
    { header: 'Customer', field: 'party_name' },
    {header: 'Debit Note Date', field: 'debit_note_date' },
    { header: 'Amount', field: 'grand_total' },
    { 
      header: 'Actions', 
      field: 'actions', 
      isAction: true, 
      actionButtons: [
        { name: 'Edit', className: 'btn-default' }, 
        { name: 'Delete', className: 'btn-cancel' },
         {
                            className: "btn-danger mt-1",
                            icon: <FaFilePdf style={{ fontSize: "15px" }} />,
                          },
      ]
    }
  ]);
 

  const [pageSize, setPageSize] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');

    const partyOptions = listParties.map((party) => ({
      value: party.id,
      label: party.ledger,
    }));

    // Load saved financial year and dates from localStorage
  const loadSavedDates = () => {
    const savedFinancialYear = localStorage.getItem("selectedFinancialYear");

    // Ensure financial year is always correctly structured
    let startYear, endYear;
    if (savedFinancialYear && savedFinancialYear.includes("-")) {
      [startYear, endYear] = savedFinancialYear.split("-");
    } else {
      // Default to the current financial year
      const currentYear = new Date().getFullYear();
      startYear = currentYear - 1; // Example: 2024 (for 2024-2025)
      endYear = currentYear; // Example: 2025 (for 2024-2025)
    }

    return {
      financialYear: savedFinancialYear || `${startYear}-${endYear}`,
      fromDate: localStorage.getItem("savedFromDate") || `${startYear}-04-01`,
      toDate: localStorage.getItem("savedToDate") || `${endYear}-03-31`,
      minDate: `${startYear}-04-01`,
      maxDate: `${endYear}-03-31`,
    };
  };

  const {
    fromDate: initialFromDate,
    toDate: initialToDate,
    minDate,
    maxDate,
    financialYear: initialFinancialYear,
  } = loadSavedDates();

const [fromDate, setFromDate] = useState(initialFromDate);
const [toDate, setToDate] = useState(initialToDate);
const [financialYear, setFinancialYear] = useState(initialFinancialYear);


useEffect(() => {
  if (!financialYear) return;

  localStorage.setItem('selectedFinancialYear', financialYear);

  let startYear, endYear;
  if (financialYear.includes('-')) {
    [startYear, endYear] = financialYear.split('-');
  } else {
    return; // Exit if financial year is not valid
  }

  const savedFromDate = localStorage.getItem('savedFromDate') || `${startYear}-04-01`;
  const savedToDate = localStorage.getItem('savedToDate') || `${endYear}-03-31`;

  setFromDate(savedFromDate);
  setToDate(savedToDate);

  if (!localStorage.getItem('savedFromDate')) localStorage.setItem('savedFromDate', savedFromDate);
  if (!localStorage.getItem('savedToDate')) localStorage.setItem('savedToDate', savedToDate);
}, [financialYear]);


  
    const fetchParties = async () => {
      try {
        const data = await dispatch(ListParties({ profile_id: id })).unwrap();
        setListParties(data?.data);
      } catch (error) {
        console.log('Error fetching parties:', error.message);
      }
    };
  
  const fetchDebitNotelist = async () => {
    setIsLoading(true);
    const params = {
      profile_id: id,
      from_date: fromDate,
      to_date: toDate,
      ledger_id: selectedParty?.value || '',
    };
    // console.log(params)
    try {
      const data = await dispatch(DebitNotelist(params)).unwrap();
      setIsLoading(false);
      setDebitNotelist(data?.data);
    } catch (error) {
      setIsLoading(false);
      setDebitNotelist([]);
      console.log('Error fetching invoices:', error.message);
    }
  };

  useEffect(() => {
    fetchParties();
    fetchDebitNotelist();
  }, [financialYear]);

  const handleFilterSubmit = (e) => {
    e.preventDefault();
    fetchDebitNotelist();
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleEdit = (item) => {
    if (item && item.id) {
      navigate(`/purchase/editdebitnote/${item.id}`);
    } else {
      console.log("Item or item.id is undefined");
    }
  };

  const handleDelete = (item) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this Debit Note?");
    if (confirmDelete) {
          setIsLoading(true);
           dispatch(debitNoteDelete({ id: item.id, profile_id: id  }))
          .unwrap()
          .then((data) => {
              setIsLoading(false);
              hindleReturn();
          })
          .catch(({ message }) => {
            setIsLoading(false);
              toast.error(message);
          });
    } else {
      console.log("Deletion canceled");
    }
  };

  const hindleReturn = () => {
    setIsLoading(true);
    dispatch(DebitNotelist({ profile_id: id }))
      .unwrap()
      .then((data) => {
        setIsLoading(false);
         setDebitNotelist(data?.data);
      })
      .catch(({ message }) => {
        setIsLoading(false);
        console.log(message);
      });
  };



  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const filtereditemList = debitNotelist?.filter(party => 
    party?.debit_note_number?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
    party?.purchase_voucher_id?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
    party?.party_name?.toLowerCase()?.includes(searchQuery?.toLowerCase())||
    party?.grand_total?.toLowerCase()?.includes(searchQuery?.toLowerCase())||
    party?.debit_note_date?.toLowerCase()?.includes(searchQuery?.toLowerCase())

  );

 // Handle date changes with validation
 const handleFromDateChange = (e) => {
  const newDate = e.target.value;
  if (newDate >= minDate && newDate <= maxDate) {
    setFromDate(newDate);
    localStorage.setItem('savedFromDate', newDate);
  } else {
       toast.error(`Select a date within the financial year ${formatFinancialYear(minDate, maxDate)}`);
  }
};

const handleToDateChange = (e) => {
  const newDate = e.target.value;
  if (newDate >= minDate && newDate <= maxDate) {
    setToDate(newDate);
    localStorage.setItem('savedToDate', newDate);
  } else {
       toast.error(`Select a date within the financial year ${formatFinancialYear(minDate, maxDate)}`);
  }
};

const formatFinancialYear = (startDate, endDate) => {
  return `(${startDate.split("-").reverse().join("-")} to ${endDate.split("-").reverse().join("-")})`;
};
  const handlePDF = (item) => {
    const data = `${API_BASE_URL}${API_PATHS.debitnotepdf}/${item?.id}`;
    navigate("/Pdf-Viewer", { state: { data } });
  };

  return (
    <AdminLayout>
        {isLoading && <Loader />}
          <div className="row content-body">
            <div className="container-fluid">
              <div className="page-header">
                <div>
                  <h2 className="main-content-title tx-24 mg-b-5">Debit Note</h2>
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <a href="#">Purchase</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                     Debit Note/Return List
                    </li>
                  </ol>
                </div>
                <div className="d-flex justify-content-end">
                  <button className="btn ripple btn-default" onClick={() => navigate('/purchase/adddebitnote')}>
                    Add Debit Note/Return
                  </button>
                </div>
              </div>

              <div class="row mb-4">
            <div class="col-md-12">
              <div class="card custom-card">
                <div class="card-body">
                  <form onSubmit={handleFilterSubmit} className="row mb-4">
                    <div className="col-md-3">
                      <label>Customer</label>
                      <Select options={partyOptions} placeholder="--Select Customer--" value={selectedParty} onChange={setSelectedParty} />
                    </div>
                    <div className="col-md-3">
                      <label>From Date</label>
                      <input type="date" className="form-control" value={fromDate} onChange={handleFromDateChange} min={minDate} max={maxDate}  />
                    </div>
                    <div className="col-md-3">
                      <label>To Date</label>
                      <input type="date" className="form-control" value={toDate} onChange={handleToDateChange} min={minDate} max={maxDate} />
                    </div>
                    <div className="col-md-3 mt-2">
                      <button type="submit" className="btn btn-default mt-4">
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

              <div className="row">
                <div className="col-md-12">
                 <Table
                    columns={columns}
                    data={filtereditemList}
                    tableRef={tableRef}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    currentPage={currentPage}
                    totalCount={filtereditemList?.length}
                    onPageChange={handlePageChange}
                    handleEdit={handleEdit}
                    handleDelete={handleDelete}
                    handlePDF={handlePDF}
                    handleSearchChange={handleSearchChange}
                  />
                </div>
              </div>
            </div>
          </div>
        </AdminLayout>
  );
};

export default DebitNoteList;
